/* eslint-disable @typescript-eslint/no-misused-promises */
import { createI18nClientProvider } from "@brightdotai/digital-water-i18n";
import { startTransition } from "react";
import { hydrateRoot } from "react-dom/client";
import { HydratedRouter } from "react-router/dom";
import { CREATE_I18N_ARGS } from "./i18n";
import { initSentry, SentryEnvironmentKeys } from "./modules/observability/sentry";
import { startVersionDriftCheck } from "./modules/observability/version-drift.client";
import { NonceContext } from "./utils/use-nonce";

async function hydrateClient() {
  initSentry({
    dsn: window[SentryEnvironmentKeys.DSN],
    environment: window[SentryEnvironmentKeys.ENVIRONMENT],
    version: window[SentryEnvironmentKeys.VERSION],
    sampleRate: window[SentryEnvironmentKeys.SAMPLE_RATE]
      ? Number(window[SentryEnvironmentKeys.SAMPLE_RATE])
      : undefined,
    tracesSampleRate: window[SentryEnvironmentKeys.TRACES_SAMPLE_RATE]
      ? Number(window[SentryEnvironmentKeys.TRACES_SAMPLE_RATE])
      : undefined,
    replaysSessionSampleRate: window[SentryEnvironmentKeys.REPLAYS_SESSION_SAMPLE_RATE]
      ? Number(window[SentryEnvironmentKeys.REPLAYS_SESSION_SAMPLE_RATE])
      : undefined,
  });

  startVersionDriftCheck();

  let I18nextClientProvider = await createI18nClientProvider(CREATE_I18N_ARGS, {
    localeVersion: __VERSION__,
  });

  startTransition(() => {
    hydrateRoot(
      document,
      <NonceContext.Provider value={window.__nonce}>
        <I18nextClientProvider>
          <HydratedRouter />
        </I18nextClientProvider>
      </NonceContext.Provider>,
    );
  });
}

if (window.requestIdleCallback) {
  window.requestIdleCallback(hydrateClient);
} else {
  // Safari doesn't support requestIdleCallback
  // https://caniuse.com/requestidlecallback
  window.setTimeout(hydrateClient, 1);
}
